import type { TextColProps } from '@/app/components/TwoColumnModule';
import TwoColumnModule from '@/app/components/TwoColumnModule';

export const motionProps = {
  initial: { filter: 'blur(5px)', opacity: 0 },
  style: { height: '100%' },
  transition: { delay: 0.5, duration: 0.5 },
  viewport: { once: true },
  whileInView: { filter: 'blur(0px)', opacity: 1 },
};

export const textCol: TextColProps = {
  eyebrowProps: {
    className: 'text-base uppercase font-bold mb-6',
    label: 'new_feature',
  },
  textColClassName: 'flex flex-col gap-12',
  titleProps: {
    className: 'mb-6',
    label: 'health_panels_title',
    height: 'tight',
    variant: 'h4',
  },

  paragraphs: [
    {
      textProps: {
        label: 'health_panels_description',
        className: 'text-base',
      },
    },
  ],
};

const buttonProps: TextColProps['buttonProps'] = {
  label: 'learn_more',
  className: 'w-fit',
  variant: 'secondary-dark',
  href: 'https://ouraring.com/blog/health-panels',
  target: '_blank',
  rel: 'noopener noreferrer',
};

const HealthPanelsSection = () => {
  return (
    <section className="pt-20" data-cy="health-panels-section">
      <TwoColumnModule
        imageCol={{
          src: 'integrations/health_panels.jpg',
          localizedAlt: 'health_panels_image_alt',
          motionProps,
        }}
        smBreakTextPos="bottom"
        mdBreakTextPos="right"
        textCol={{ ...textCol, buttonProps }}
      />
    </section>
  );
};

export default HealthPanelsSection;
